export default __webpack_public_path__ + "media/10-sec-countdown-with-echo-77616.f2cbfea6.mp3";